import parseDate from 'api/base/parseDate'
import dataMapper from 'utils/dataMapper'

export const mapReportExpected = dataMapper(data => ({
    id: data.id,
    name: data.name,
    dates: (data.dates || null).map(parseDate),
}))
